@if (jobDetails) {
    <div class="w-full lg:max-w-7xl p-8">
        <div class="prose prose-sm !max-w-100">
            <h2 class="flex gap-2 items-center">
                @if (jobDetails.status == jobStatus.FINISHED) {
                    <mat-icon class="relative icon-size-6 text-green-600" fontIcon="check_circle"></mat-icon>
                }
                @if (jobDetails.status == jobStatus.FINISHED_WITH_FAILURES) {
                    <mat-icon class="relative icon-size-6 text-red-800" fontIcon="cancel"></mat-icon>
                }
                @if (jobDetails.status == jobStatus.PROCESSING) {
                    <mat-icon class="relative animate-spin icon-size-6 text-blue-600" fontIcon="autorenew"></mat-icon>
                }
                {{ 'label_jobs' | translate }} {{ jobDetails.id }}
                {{ jobDetails.displayName && ' - ' + jobDetails.displayName }}
            </h2>
        </div>
        <div class="whitespace-nowrap">
            <div>
                {{ 'label_created_at' | translate }}:
                {{ jobDetails.createdAt | date: 'dd.MM.yyyy HH:mm:ss' }}
            </div>
            <div>{{ 'label_created_by' | translate }}: {{ jobDetails.createdByUsername }} ({{ jobDetails.createdBy }})</div>
        </div>
        <mat-divider class="my-4"></mat-divider>
        <h2 class="text-2xl flex items-center justify-between">
            {{ 'label_tasks' | translate }}
            <button
                [disabled]="jobDetails.status != jobStatus.FINISHED_WITH_FAILURES"
                mat-icon-button
                type="button"
                matTooltipShowDelay="500"
                [matTooltip]="'label_retry_all_failed_job_messages' | translate"
                (click)="onRetryFailedMessages()"
            >
                <mat-icon class="icon-size-7" fontIcon="refresh"></mat-icon>
            </button>
        </h2>
        <div>{{ 'info_tasks_information' | translate }}</div>
        <div id="header" class="flex flex-col flex-auto justify-between gap-6 mt-6">
            <div class="w-full gap-x-6 flex">
                <div class="flex flex-col p-3 pl-0 text-center">
                    <div class="text-sm font-medium leading-none text-secondary">
                        {{ 'label_count' | translate }}
                    </div>
                    <div class="mt-2 font-medium text-2xl leading-none">
                        {{ jobDetails.numMessages }}
                    </div>
                </div>
                <mat-divider [vertical]="true"></mat-divider>
                <div
                    class="status-square"
                    [ngClass]="{
                        'border-inherit brightness-75': this.filterStatuses.includes(processingStatus.QUEUED),
                    }"
                    (click)="onFilterChanged(processingStatus.QUEUED)"
                >
                    <div class="text-sm font-medium leading-none text-secondary">
                        {{ 'label_queued' | translate }}
                    </div>
                    <div class="mt-2 font-medium text-2xl leading-none">
                        {{ jobDetails.numQueuedMessages }}
                    </div>
                </div>
                <div
                    class="status-square"
                    [ngClass]="{
                        'border-inherit brightness-75': this.filterStatuses.includes(processingStatus.PROCESSING),
                    }"
                    (click)="onFilterChanged(processingStatus.PROCESSING)"
                >
                    <div class="text-sm font-medium leading-none text-secondary">
                        {{ 'label_processing' | translate }}
                    </div>
                    <div class="mt-2 font-medium text-2xl leading-none">
                        {{ jobDetails.numProcessingMessages }}
                    </div>
                </div>
                <div
                    class="status-square"
                    [ngClass]="{
                        'border-inherit brightness-75': this.filterStatuses.includes(processingStatus.FAILED),
                    }"
                    (click)="onFilterChanged(processingStatus.FAILED)"
                >
                    <div class="text-sm font-medium leading-none text-secondary">
                        {{ 'label_failed' | translate }}
                    </div>
                    <div class="mt-2 font-medium text-2xl leading-none">
                        {{ jobDetails.numFailedMessages }}
                    </div>
                </div>
                <div
                    class="status-square"
                    [ngClass]="{
                        'border-inherit brightness-75': this.filterStatuses.includes(processingStatus.SUCCESSFUL),
                    }"
                    (click)="onFilterChanged(processingStatus.SUCCESSFUL)"
                >
                    <div class="text-sm font-medium leading-none text-secondary">
                        {{ 'label_finished' | translate }}
                    </div>
                    <div class="mt-2 font-medium text-2xl leading-none">
                        {{ jobDetails.numSuccessfulMessages }}
                    </div>
                </div>
                <div
                    class="status-square"
                    [ngClass]="{
                        'border-inherit brightness-75': this.filterStatuses.includes(processingStatus.CANCELLED),
                    }"
                    (click)="onFilterChanged(processingStatus.CANCELLED)"
                >
                    <div class="text-sm font-medium leading-none text-secondary">
                        {{ 'label_cancelled' | translate }}
                    </div>
                    <div class="mt-2 font-medium text-2xl leading-none">
                        {{ jobDetails.numCancelledMessages }}
                    </div>
                </div>
            </div>
            <div class="mat-table-wrapper">
                <div class="overflow-x-auto">
                    <table matSort mat-table [dataSource]="dataSource" class="w-full" (matSortChange)="sortData($event)">
                        <ng-container matColumnDef="id">
                            <th mat-sort-header="id" mat-header-cell *matHeaderCellDef>#</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.id }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="type">
                            <th mat-sort-header="type" mat-header-cell *matHeaderCellDef>
                                {{ 'label_type' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ 'label_message_' + element.type | translate }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-sort-header="status" mat-header-cell *matHeaderCellDef>
                                {{ 'label_status' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element.status == processingStatus.SUCCESSFUL) {
                                    <mat-icon
                                        class="relative top-1 icon-size-5 text-green-600"
                                        fontIcon="check_circle"
                                        [matTooltip]="getStatusMessage(element)"
                                    ></mat-icon>
                                }
                                @if (element.status == processingStatus.FAILED) {
                                    <mat-icon
                                        class="relative top-1 icon-size-5 text-red-800"
                                        fontIcon="cancel"
                                        [matTooltip]="getStatusMessage(element)"
                                    ></mat-icon>
                                }
                                @if (element.status == processingStatus.PROCESSING) {
                                    <mat-icon
                                        class="relative animate-spin top-1 icon-size-5 text-blue-600"
                                        fontIcon="autorenew"
                                        [matTooltip]="getStatusMessage(element)"
                                    ></mat-icon>
                                }
                                @if (element.status == processingStatus.QUEUED) {
                                    <mat-icon
                                        class="relative top-1 icon-size-5 text-gray-500"
                                        fontIcon="schedule"
                                        [matTooltip]="getStatusMessage(element)"
                                    ></mat-icon>
                                }
                                @if (element.status == processingStatus.CANCELLED) {
                                    <mat-icon
                                        class="relative top-1 icon-size-5 text-gray-500"
                                        fontIcon="block"
                                        [matTooltip]="getStatusMessage(element)"
                                    ></mat-icon>
                                }
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="created_at">
                            <th mat-sort-header="created_at" mat-header-cell *matHeaderCellDef>
                                {{ 'label_created_at' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span>{{ element.createdAt | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="last_activity_at">
                            <th mat-sort-header="last_activity_at" mat-header-cell *matHeaderCellDef>
                                {{ 'label_last_activity_at' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span>{{ element.timeStamp | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="retries">
                            <th mat-sort-header="retries" mat-header-cell *matHeaderCellDef>
                                {{ 'label_retries' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span>{{ element.retries }}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="error">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_failed' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span>{{ element.errorSentryId }}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-icon class="icon-size-5 relative top-1" fontIcon="more_horiz"></mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="flex">
                                    <button
                                        mat-icon-button
                                        type="button"
                                        matTooltipShowDelay="500"
                                        [matTooltip]="'label_open_message_details' | translate"
                                        (click)="onShowMessageDetails(element)"
                                    >
                                        <mat-icon class="icon-size-5" fontIcon="info"></mat-icon>
                                    </button>
                                    @if (element.status == processingStatus.FAILED) {
                                        <button
                                            mat-icon-button
                                            type="button"
                                            matTooltipShowDelay="500"
                                            [matTooltip]="'label_retry_failed_job_messages' | translate"
                                            (click)="onRetryFailedMessage(element)"
                                        >
                                            <mat-icon class="icon-size-5" fontIcon="refresh"></mat-icon>
                                        </button>
                                    }
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        <tr class="mat-row relative" *matNoDataRow>
                            <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                                <span>
                                    <div class="font-medium text-secondary">
                                        {{
                                            'info_tasks_found_count'
                                                | translate
                                                    : {
                                                          count: 0,
                                                      }
                                        }}
                                    </div>
                                </span>
                            </div>
                        </tr>
                    </table>
                </div>
                <mat-paginator
                    #tablePaginator
                    class="justify-end"
                    showFirstLastButtons
                    [pageSize]="pageSize"
                    [length]="totalNumberOfMessages"
                    [pageSizeOptions]="[10, 25, 50, 100]"
                    (page)="pageChanged($event)"
                    [pageIndex]="pageNumber"
                >
                </mat-paginator>
            </div>
        </div>
    </div>
}
